import { LanguageCode } from './types';
import type { LanguageCodeType } from './index';

export const isInLangList = (lang: LanguageCodeType) => {
  return Object.values(LanguageCode).map((l) => l.toLowerCase()).includes((lang || '').toLowerCase());
};

// 精确匹配
const getLanguageCodeFromExactMatch = (lang: string): LanguageCodeType | undefined => {
  return Object.values(LanguageCode).map((l) => ({ key: l, value: l.toLowerCase() })).find((l) => (lang || '').toLowerCase() === l.value)?.key as LanguageCodeType;
};

// 模糊匹配
const getLanguageCodeFromFuzzyMatch = (lang: string): LanguageCodeType | undefined => {
  return Object.values(LanguageCode).map((l) => { return { key: l, value: l.toLowerCase() }; }).find((l) => lang.startsWith(l.value))?.key as LanguageCodeType;
};

export const mapLanguageCode = (lang: string): LanguageCodeType => {
  const lowerLang = (lang || '').toLowerCase();
  if (isInLangList(lowerLang as LanguageCodeType)) {
    if (lowerLang === LanguageCode.zh) {
      return LanguageCode.zhHans;
    }
    if (lowerLang === LanguageCode.zhHant.toLowerCase()) {
      return LanguageCode.en;
    }
    return getLanguageCodeFromExactMatch(lowerLang) || LanguageCode.en;
  }
  const code = getLanguageCodeFromFuzzyMatch(lowerLang);

  if (code) {
    return code === LanguageCode.zh ? LanguageCode.zhHans : code;
  }
  return LanguageCode.en;
};
